import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Check, ArrowRight } from 'lucide-react';

const PaymentSuccess = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#2c3e50] flex items-center justify-center px-4" data-testid="payment-success-page">
      <div className="w-full max-w-lg">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-white tracking-tight">Unbox'D Autism</h1>
          <p className="text-sm text-gray-300 mt-1 uppercase tracking-widest">Coaching & Consulting</p>
        </div>

        <Card className="border-0 shadow-2xl">
          <CardContent className="pt-8 pb-8 space-y-6 text-center">
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto">
              <Check className="w-10 h-10 text-green-600" />
            </div>
            <h2 className="text-2xl font-bold text-[#2c3e50]">Payment Confirmed!</h2>
            <p className="text-gray-500">
              Welcome to the Unbox'D family! Your next step is to create your account and complete the intake form so Coach Robin can prepare for your first session.
            </p>

            <div className="bg-[#FAF7F2] rounded-lg p-5 text-left space-y-3">
              <h3 className="font-semibold text-[#2c3e50]">Here's what happens next:</h3>
              <div className="space-y-2 text-sm text-gray-600">
                <div className="flex items-start gap-2">
                  <span className="w-6 h-6 rounded-full bg-[#C97B5A] text-white text-xs flex items-center justify-center flex-shrink-0 mt-0.5">1</span>
                  <span>Create your account (takes 30 seconds)</span>
                </div>
                <div className="flex items-start gap-2">
                  <span className="w-6 h-6 rounded-full bg-[#C97B5A] text-white text-xs flex items-center justify-center flex-shrink-0 mt-0.5">2</span>
                  <span>Complete the intake form so Robin knows your family's story</span>
                </div>
                <div className="flex items-start gap-2">
                  <span className="w-6 h-6 rounded-full bg-[#C97B5A] text-white text-xs flex items-center justify-center flex-shrink-0 mt-0.5">3</span>
                  <span>Robin will review everything and reach out to schedule your first session</span>
                </div>
              </div>
            </div>

            <Button
              onClick={() => navigate('/join/unboxd2026')}
              className="w-full bg-[#C97B5A] hover:bg-[#b86a4a] text-white text-lg py-6"
              data-testid="create-account-btn"
            >
              Create Your Account <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default PaymentSuccess;
